// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import _ from 'zutil';
import { use_search } from '../../ui/use_search';
import { Top_sites } from '../../unblock/top_sites.js';
import { use_was_opened } from './use_was_opened';
import styles from './sites_menu.module.less';
var Sites_menu = /*#__PURE__*/forwardRef((props, ref) => {
  useTranslation();
  var opened = props.opened;
  var was_opened = use_was_opened(opened);
  var search = use_search(props);
  var cls = cn(styles.sites_menu, !opened && styles.closed);
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, was_opened && /*#__PURE__*/React.createElement(Top_sites, _extends({}, props, {
    limit: 5,
    search: search,
    cols_count: {
      xs: 2,
      sm: 2,
      md: 3,
      lg: 3,
      xl: 6
    },
    on_get_more: _.noop,
    sitepics_only: true,
    with_column: true
  }))));
});
export { Sites_menu };